<template>
  <div class="etms-router-body">
    <div class="etms-router-search">
      <span class="etms-router-search-label fl">渠道：</span>
      <el-select size="mini" placeholder="选择渠道搜索" v-model="search.ChannelId" class="etms-router-search-element fl" filterable clearable></el-select>
      <span class="etms-router-search-label fl">对接分类：</span>
      <el-select size="mini" placeholder="选择对接分类搜索" v-model="search.DockingType" class="etms-router-search-element fl" filterable clearable></el-select>
      <span class="etms-router-search-label fl">状态：</span>
      <el-select size="mini" placeholder="选择状态搜索" v-model="search.State" class="etms-router-search-element fl" filterable clearable></el-select>
      <el-tooltip class="item" effect="dark" content="添加" placement="top">
        <el-button size="mini" @click="insertChannelDocking" class="etms-router-search-button fr" type="primary" icon="el-icon-plus"></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="查询" placement="top">
        <el-button size="mini" @click="searchChannelDocking" class="etms-router-search-button fr" type="primary" icon="el-icon-search"></el-button>
      </el-tooltip>
      <div class="clear"></div>
    </div>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageindex" :page-sizes="pagesizes" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="recordcount"></el-pagination>
    <el-table :border="true" :data="channeldockings" height="90%" class="etms-router-list">
      <el-table-column type="index" label="序号" header-align="center" align="center"></el-table-column>
      <el-table-column label="渠道" width="250px" prop="ChannelName_CN"></el-table-column>
      <el-table-column label="分类" prop="ChannelType"></el-table-column>
      <el-table-column label="账号" prop="AccountName" width="220px"></el-table-column>
      <el-table-column label="密码" prop="Password" width="100px"></el-table-column>
      <el-table-column label="授权码" prop="Authcode"></el-table-column>
      <el-table-column label="token" prop="Token" width="100px"></el-table-column>
      <el-table-column label="版本号" prop="Version" width="100px"></el-table-column>
      <el-table-column label="对接渠道" prop="DockingChannelId" width="100px"></el-table-column>
      <el-table-column label="状态" prop="Token" width="100px"></el-table-column>
      <el-table-column label="操作" width="140px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index,scope.row)" icon="el-icon-edit-outline" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)" icon="el-icon-delete" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="dialogtitle" :visible.sync="dialogvisible" center :modal-append-to-body="false">
      <el-form :ref="formname" label-width="120px" class="etms-dialog-form">

        <el-tabs v-model="activename">
          <el-tab-pane label="对接信息" name="dockinginfo" class="el-form-half">
            <el-form-item label="渠道：">
              <el-select size="mini" placeholder="请选择渠道" v-model="form.ChannelId" class="el-width-200" filterable></el-select>
            </el-form-item>
            <el-form-item label="分类：">
              <el-select size="mini" placeholder="请选择分类" v-model="form.DockingType" class="el-width-200" filterable @change="dockingTypeChange">
                <el-option v-for="item in channelDockingTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="帐号：" v-show="platformshow">
              <el-input size="mini" placeholder="请输入登陆帐号" v-model="form.AccountName" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="密码：" v-show="platformshow">
              <el-input size="mini" placeholder="请输入密码" v-model="form.Password" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="授权码：" v-show="platformshow">
              <el-input size="mini" placeholder="请输入授权码" v-model="form.AuthCode" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="Token：" v-show="platformshow">
              <el-input size="mini" placeholder="请输入Token" v-model="form.Token" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="版本号：" v-show="platformshow">
              <el-input size="mini" placeholder="请输入版本号" v-model="form.Version" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="授权网址：" v-show="platformshow">
              <el-input size="mini" placeholder="请输入授权网址" v-model="form.AuthUrl" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="渠道网址：" v-show="platformshow">
              <el-input size="mini" placeholder="请输入渠道网址" v-model="form.ChannelUrl" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="抓单网址：" v-show="platformshow">
              <el-input size="mini" placeholder="请输入抓单网址" v-model="form.OddUrl" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="提交网址：" v-show="platformshow">
              <el-input size="mini" placeholder="请输入预报网址" v-model="form.SubmitUrl" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="标签网址：" v-show="platformshow">
              <el-input size="mini" placeholder="请输入标签获取网址" v-model="form.LabelUrl" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="打单网址：" v-show="platformshow">
              <el-input size="mini" placeholder="请输入打单网址" v-model="form.PrintUrl" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="对接发货商家：" v-show="shippershow">
              <el-select size="mini" placeholder="请选择对接发货商家" v-model="form.ShipperId" class="el-width-200" filterable></el-select>
            </el-form-item>
            <el-form-item label="对接渠道：">
              <el-select size="mini" placeholder="请选择对接渠道" v-model="form.DockingChannelId" class="el-width-200" filterable></el-select>
            </el-form-item>
            <el-form-item label="对接标签：" v-show="platformshow">
              <el-select size="mini" placeholder="请选择对接标签" v-model="form.DockingLabelId" class="el-width-200" filterable></el-select>
            </el-form-item>
            <el-form-item label="默认状态：" v-show="platformshow">
              <el-checkbox v-model="form.DefaultState" label="默认"></el-checkbox>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="对接地址" name="dockingaddress" class="el-form-half" v-if="addressshow">
            <el-form-item label="联系人中文：">
              <el-input size="mini" placeholder="请填写中文联系人" v-model="form.ContactName_CN" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="联系人英文：">
              <el-input size="mini" placeholder="请填写英文联系人" v-model="form.ContactName_EN" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="公司中文：">
              <el-input size="mini" placeholder="请填写中文公司名" v-model="form.CompanyName_CN" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="公司英文：">
              <el-input size="mini" placeholder="请填写英文公司名" v-model="form.CompanyName_EN" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="地区：">
              <el-cascader size="mini" placeholder="请选择所在地区" :options="regions" v-model="form.Region" filterable class="el-width-200"></el-cascader>
            </el-form-item>
            <el-form-item label="街道地址中文：">
              <el-input size="mini" placeholder="请填写中文街道地址" v-model="form.StreetAddress_CN" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="街道地址英文：">
              <el-input size="mini" placeholder="请填写英文街道地址" v-model="form.StreetAddress_EN" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="邮编：">
              <el-input size="mini" placeholder="请填写邮编" v-model="form.Zipcode" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="固定电话：">
              <el-input size="mini" placeholder="请填写固定电话" v-model="form.TelPhone" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="手机号码：">
              <el-input size="mini" placeholder="请填写手机号码" v-model="form.MobilePhone" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="邮箱地址：">
              <el-input size="mini" placeholder="请填写邮箱地址" v-model="form.Email" class="el-width-200"></el-input>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="dialogSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    return {
      regions: this.regionmodule.regions,
      channelDockingTypes: this.constant.channelDockingTypes,
      pagesizes: this.constant.pagesizes,
      pageindex: 1,
      pagesize: 100,
      recordcount: 0,
      dialogtitle: '添加对接信息',
      dialogvisible: true,
      activename: 'dockinginfo',
      formname: 'form',
      platformshow: false,
      shippershow: false,
      addressshow: false,
      search: {
        ChannelId: '',
        DockingType: '',
        State: '',
      },
      channeldockings: [

      ],
      form: {
        ShipperId: '',
        ChannelId: '',
        DockingType: '',
        AccountName: '',
        Password: '',
        AuthCode: '',
        Token: '',
        Version: '',
        AuthUrl: '',
        ChannelUrl: '',
        OddUrl: '',
        SubmitUrl: '',
        LabelUrl: '',
        PrintUrl: '',
        DockingChannelId: '',
        DockingLabelId: '',
        ContactName_CN: '',
        ContactName_EN: '',
        CompanyName_CN: '',
        CompanyName_EN: '',
        Region: [],
        StreetAddress_CN: '',
        StreetAddress_EN: '',
        Zipcode: '',
        TelPhone: '',
        MobilePhone: '',
        Email: '',
      }
    }
  },
  methods: {
    searchChannelDocking () { },
    insertChannelDocking () { },
    handleSizeChange (val) { },
    handleCurrentChange (val) { },
    handleEdit (index, row) { },
    handleDelete (index, row) { },
    dialogSave () { },
    dockingTypeChange () {
      switch (this.form.DockingType) {
        case 0:
          this.shippershow = true
          this.platformshow = false
          this.addressshow = false
          break;
        case 1:
        case 2:
        case 3:
        case 4:
          this.shippershow = false
          this.platformshow = true
          this.addressshow = true
          break
        default:
          this.shippershow = false
          this.platformshow = true
          this.addressshow = false
          break;
      }
    },
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/channel_docking.vue